// CertificateCard.js

import React, { useState } from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { BsFillAwardFill } from "react-icons/bs";
import { CgWebsite } from "react-icons/cg";

function CertificateCard(props) {
  const [expanded, setExpanded] = useState(false);

  const maxLength = 180;
  const isLong = props.description.length > maxLength;

  const displayText = expanded
    ? props.description
    : `${props.description.slice(0, maxLength)}${
        isLong ? "..." : ""
      }`;

  return (
    <>
      <Card className="certificate-card-view">

        {/* Image */}
        <div className="certificate-image-container">
          <Card.Img
            variant="top"
            src={props.imgPath}
            alt="certificate"
            className="certificate-image"
          />
        </div>

        <Card.Body className="certificate-body">

          {/* Title */}
          <div className="certificate-header">
            <Card.Title className="certificate-title">
              {props.title}
            </Card.Title>

            <Card.Subtitle className="certificate-issuer">
              {props.issuer}
            </Card.Subtitle>
          </div>

          {/* Description */}
          <div
            className={`certificate-description ${
              expanded ? "expanded" : ""
            }`}
          >
            <Card.Text>
              {displayText}
            </Card.Text>

            {isLong && (
              <div className="read-more-wrapper">
                <span
                  className="read-more"
                  onClick={() => setExpanded(!expanded)}
                >
                  {expanded ? "Show less ▲" : "Read more ▼"}
                </span>
              </div>
            )}
          </div>

          {/* Buttons */}
          <div className="certificate-buttons">
            {props.certLink && (
              <Button
                variant="success"
                href={props.certLink}
                target="_blank"
              >
                <BsFillAwardFill />
                &nbsp; View Certificate
              </Button>
            )}

            {props.demoLink && (
              <Button
                variant="info"
                href={props.demoLink}
                target="_blank"
                style={{ marginLeft: "10px" }}
              >
                <CgWebsite />
                &nbsp; Visit
              </Button>
            )}
          </div>

        </Card.Body>
      </Card>

      <style>{`

        .certificate-card-view{
            background: rgba(255,255,255,0.03);
            backdrop-filter: blur(10px);
            border:1px solid rgba(199,112,240,.25);
            border-radius:25px;
            overflow:hidden;

            height:680px;
            display:flex;
            flex-direction:column;

            transition:.35s ease;
            box-shadow:0 0 25px rgba(199,112,240,.25);
        }

        .certificate-card-view:hover{
            transform:translateY(-8px);
            box-shadow:0 0 40px rgba(199,112,240,.55);
        }

        .certificate-image-container{
            padding:25px 25px 0;
        }

        .certificate-image{
            height:220px;
            width:100%;
            object-fit:cover;
            border-radius:15px;
        }

        .certificate-body{
            display:flex;
            flex-direction:column;
            flex:1;
            padding:25px;
        }

        .certificate-header{
            min-height:100px;
        }

        .certificate-title{
            color:white;
            font-size:1.8rem;
            font-weight:700;
            text-align:center;
            margin-bottom:10px;
        }

        .certificate-issuer{
            text-align:center;
            color:#aaa !important;
            font-size:1.2rem;
        }

        .certificate-description{
            flex:1;
            margin-top:20px;
            color:white;
            text-align:justify;
            line-height:1.8;
            min-height:180px;

            display:flex;
            flex-direction:column;
        }

        /* When expanded make it scrollable */
        .certificate-description.expanded{
            max-height:220px;
            overflow-y:auto;
            padding-right:10px;
        }

        /* Scrollbar */
        .certificate-description.expanded::-webkit-scrollbar{
            width:6px;
        }

        .certificate-description.expanded::-webkit-scrollbar-track{
            background:rgba(255,255,255,.1);
            border-radius:10px;
        }

        .certificate-description.expanded::-webkit-scrollbar-thumb{
            background:#c770f0;
            border-radius:10px;
        }

        .read-more-wrapper{
            margin-top:10px;
            position:sticky;
            bottom:0;
            background:rgba(18,10,40,.95);
            padding-top:8px;
        }

        .read-more{
            color:#00d4ff;
            cursor:pointer;
            font-weight:600;
            user-select:none;
        }

        .read-more:hover{
            color:#4de3ff;
        }

        .certificate-buttons{
            margin-top:auto;
            display:flex;
            justify-content:center;
            padding-top:20px;
        }

        .certificate-buttons .btn{
            padding:10px 18px;
            border-radius:10px;
        }

        @media(max-width:768px){

            .certificate-card-view{
                height:auto;
            }

            .certificate-image{
                height:180px;
            }

            .certificate-description.expanded{
                max-height:250px;
            }
        }

      `}</style>
    </>
  );
}

export default CertificateCard;